import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { MENU } from "@store/theme/design";
import { css } from "styled-components";

export const menuMobileButtonProps: ButtonPresentationProps = {
    shape: "rectangle",
    size: undefined,
    buttonType: undefined,
    css: css`
        display: flex;
        color: ${getColor("header.contrastMain")};
        align-items: center;
        height: 100%;
        border: 0;
        background-color: transparent;
        padding: 0 ${MENU.mobileButtonSpacing};
        font-size: inherit;
        transition: none;

        &:focus {
            outline: none;
        }

        ${ButtonIcon} {
            top: auto;
            width: 20px;
            height: 20px;

            svg {
                width: inherit;
                height: inherit;
            }
        }
    `,
};
